import React from "react"
import './step-description.scss'


const StepDescription = (props: Interfaz) => {
   const {
      number,
      title,
      description,
   } = props;

   return (
      <div className='m-stepDescription__details-info'>
         <div className='m-stepDescription__details-numbercontainer'>
            <p className='m-stepDescription__details-number'>{number}</p>
         </div>
         <h3 className='m-stepDescription__details-title'>
            {title}
         </h3>
         { description &&
            <div className='m-stepDescription__details-desc'>
               {description}
            </div>
         }
      </div>
   )
}

interface Interfaz {
   number: number,
   title: string,
   description: any,
}

export default StepDescription
